// extracted by mini-css-extract-plugin
export var contrastLow = "_3e-1";
export var externalLink = "_3e-2";
export var externalLinkIcon = "_3e-3";
export var link = "_3e-0";
export var linkLabel = "_3e-4";